import axios from 'axios';
import picsioConfig from '../../../../../config';
import { getLatestCollection } from '../history';

function getBulkExportStartedNotificationsUrl() {
  return picsioConfig.zipperZipUrl.replace(/\/zip$/, '/bulkExportStartedNotifications');
}

export default function notifyBulkExportStartedToSlack({
  user,
  assets = [],
  data = {},
  config = {},
}) {
  const payload = {
    ...data,
    ids: assets.map((asset) => asset._id),
    user: user._id,
    initiatedFrom: config.initiatedFrom,
  };

  if (config.collectionId) {
    payload.collectionId = config.collectionId;
  }

  const downloadFrom = getLatestCollection();
  if (downloadFrom) {
    payload.downloadFrom = downloadFrom;
  }

  if (picsioConfig.isProofing) {
    payload.websiteId = picsioConfig.access._id;
  }

  return axios.post(
    getBulkExportStartedNotificationsUrl(),
    payload,
    { headers: { 'Content-Type': 'application/json' } },
  );
}
